import ExternalLinkIcon from "@assets/icons/external-link.svg";

import usePlatformStore from "@store/usePlatformStore";
import { useTimezones } from "@hooks/useTimezones";
import { cn } from "@utils/tailwind.util";
import { IMeeting } from "@interfaces/meeting.interface";
import { getMeetingTypeData, getParsedMeetingTime } from "@utils/meeting.util";
import { openMeetingsList } from "@utils/navigation.util";
import { Button } from "@ui/Button";
import { View } from "@ui/View";

interface Props {
  meeting?: IMeeting | null;
  size?: "small" | "large";
  showDateAndTime?: boolean;
  isRecurringSeries?: boolean;
}

export function MeetingInfo({
  meeting,
  size = "large",
  showDateAndTime,
  isRecurringSeries,
}: Props) {
  const { itemSubject } = usePlatformStore();
  const { userTimezoneOffset } = useTimezones();

  const meetingColor = getMeetingTypeData(meeting?.type)?.color;

  const parsedMeetingDate = meeting
    ? getParsedMeetingTime(
        new Date(meeting?.start_time),
        new Date(meeting?.end_time),
        userTimezoneOffset
      ).parsedMeetingTime
    : "";

  const handleOpenMeetingInNewTab = () => {
    openMeetingsList(meeting?.id);
  };

  return (
    <div className="flex gap-2">
      <div
        className="min-h-[24px] w-[3px] rounded-md"
        style={{ backgroundColor: meetingColor || "#EF4444" }}
      />

      <div className="w-full flex justify-between items-start gap-4">
        <div
          className="flex flex-col text-content-primary dark:text-white hover:opacity-75 cursor-pointer"
          onClick={handleOpenMeetingInNewTab}
        >
          <h2
            className={cn(
              "text-xl font-semibold break-words w-full",
              size === "large" ? "text-xl" : "text-sm"
            )}
            style={{ overflowWrap: "anywhere" }}
          >
            {meeting?.title || itemSubject || "Untitled"}
          </h2>

          <View.Condition if={showDateAndTime}>
            <div className="mt-1 text-sm">{parsedMeetingDate}</div>
          </View.Condition>

          <View.Condition if={isRecurringSeries}>
            <div className="mt-1 text-sm text-gray-450 dark:text-gray-100">Recurring series</div>
          </View.Condition>
        </div>

        <Button
          buttonType={"TRANSPARENT"}
          onClick={handleOpenMeetingInNewTab}
          className={cn("p-0 dark:hover:bg-gray-700", size === "large" ? "h-8 w-8" : "h-6 w-6")}
        >
          <ExternalLinkIcon className="text-content-primary dark:text-white" />
        </Button>
      </div>
    </div>
  );
}
